import { isSupported, apply } from "invokers-polyfill/fn";
if (!isSupported()) apply();